import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, UserBlockedGuard, TranslateResolver } from '@motivforce/mx-library-angular';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./authentication/authentication.module').then((m) => m.AuthenticationModule),
    canActivate: [],
  },
  {
    path: 'home',
    data: { breadcrumbLabel: (data: any) => data.translate.instant('Home'), pageTitleKey: 'Home' },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./home/home.module').then((m) => m.HomeModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'my-account',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('My Account'),
      pageTitleKey: 'My Account',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./my-account/my-account.module').then((m) => m.MyAccountModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'sales-promotions',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Sales Promotions'),
      pageTitleKey: 'Promotions',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./sales-promotions/sales-promotions.module').then((m) => m.SalesPromotionsModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'milestones',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Milestones'),
      pageTitleKey: 'Milestones',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./milestones/milestones.module').then((m) => m.MilestonesModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'terms-and-conditions',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Terms and Conditions'),
      pageTitleKey: 'Terms and Conditions',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [],
  },
  {
    path: 'support',
    loadChildren: () => import('./support/support.module').then((m) => m.SupportModule),
    canActivate: [],
  },
  {
    path: 'not-allowed',
    loadChildren: () => import('@motivforce/mx-library-angular').then((m) => m.ContentModule),
    canActivate: [],
  },
  {
    path: 'program-overview',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Program Overview'),
      pageTitleKey: 'About Lenovo 360 Boost',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./program-overview/program-overview.module').then((m) => m.ProgramOverviewModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'training-and-certifications',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Training & Certifications'),
      pageTitleKey: 'Training and Certifications',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () =>
      import('./training-and-certifications/training-and-certifications.module').then(
        (m) => m.TrainingAndCertificationsModule
      ),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'submit-an-activity',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Submit an Activity'),
      pageTitleKey: 'Submit an Activity',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./submit-an-activity/submit-an-activity.module').then((m) => m.SubmitAnActivityModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'reward-catalog',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Reward Catalog'),
      pageTitleKey: 'Reward Catalog',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./product-catalogue/product-catalogue.module').then((m) => m.ProductCatalogueModule),
    canActivate: [AuthGuard, UserBlockedGuard],
  },
  {
    path: 'email-view',
    data: { hideHeaderFooter: true },
    loadChildren: () => import('./email-view/email-view.module').then((m) => m.EmailViewModule),
    canActivate: [],
  },
  {
    path: 'unsubscribe',
    data: {
      breadcrumbLabel: (data: any) => data.translate.instant('Unsubscribe'),
      pageTitleKey: 'Unsubscribe',
    },
    resolve: { translate: TranslateResolver },
    loadChildren: () => import('./unsubscribe/unsubscribe.module').then((m) => m.UnsubscribeModule),
    canActivate: [],
  },
  {
    path: '**',
    redirectTo: '/home',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'top',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
